import { json, Link as LinkRouter } from "react-router-dom"
import { userActions } from "../service"

function LogIn(props) {

    const logIn = (e) => {
        e.preventDefault()
        let data = {
            email: e.target[0].value,
            password: e.target[1].value
        }
        userActions.logIn(data)
            .then(res => {
                localStorage.setItem("token", res.response.token)
                setTimeout(3000,

                    res.success && (window.location.replace("/backoffice"))
                )
            })
    }

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", height: "100vh", backgroundColor: "gray", justifyContent: "center" }}>

            <h1 style={{ margin: "5rem" }}>LOG-IN</h1>


            <form onSubmit={(e) => logIn(e)} id="formLogIn" style={{ display: "flex", flexDirection: "column" }}>
                <label htmlFor="email">Email</label>
                <input className="input" type="text" name="email" id="email" />
                <label htmlFor="password">Contraseña</label>
                <input className="input" type="password" name="password" id="password" />
                <input type="submit" style={{ border: "none", width: "50%", }} />
            </form>

            <LinkRouter style={{ color: "black", fontWeight: "900", marginTop: "2rem" }} to={"/"}> <button>Home</button></LinkRouter>
        </div >
    )
}

export default LogIn